import Home from './googleAnalytics/Home';
import Store from './googleAnalytics/redux/store';
import { Provider } from 'react-redux';
function App() {
  return (
    <Provider store={Store}>
      <Home />
    </Provider>
  );
}
export default App;
